import { Environment } from './models/environment';

export const environment: Environment = {
  production: true,
  name: 'PRODUCTION',
  formCarryUrl: 'https://formcarry.com/s/',
  formCarryApi:
    'Jpsop0D9TBJVm8akHL8LAvWJT2U9fKvgZp5cDO8W5AUNIEEcSOUNgqJCV7E4zmUj',
  social: 'https://social.meplis.com',
  socialV1: 'https://api.meplis.com/social/v1',
  socialV2: 'https://api.meplis.com/social/v1',
  apiUrl: 'https://api.meplis.com/',
  campusV1: 'https://api.meplis.com/trc/v1',
  campusV2: 'https://api.meplis.com/trc/v2',
  campusV3: 'https://api.meplis.com/trc/v3',
  chainV2: 'https://api.meplis.com/chain/v2',
  filesV1: 'https://api.meplis.com/files/v1',
  filesV2: 'https://api.meplis.com/files/v2',
  filesV3: 'https://api.meplis.com/files/v3',
  staticUrl: 'https://static.meplis.com/',
  translateUrl: 'https://i18n.meplis.com/',
  imagesHost: 'https://image.meplis.com',
  vonageApplicationId: '5901df69-0cab-43de-80f4-67fbd8c4d05b',

  authentication: {
    clientToken: '641c80669c68a73ead37f994',
    supportsTokenAccess: true,
  },
  google: {
    analyticsStorageId: 'ga-campus-production',
    analyticsTrackerId: 'G-3PL1EYST0G',
    mapsKey: 'AIzaSyCARfd30IYGP7PvKdvkRKFcGVyeUPnrk6U',
    recaptchaKey: '6Lc2MIUpAAAAANU2lDbvr_IFUUjTk9ajlimlw3fC',
  },
  oneSignal: {
    appId: '5019a63b-beaa-417c-9617-316c9c922b80',
    debug: false,
  },
};
